import { useEffect } from "react";

/**
 * The "Skip to Main Content" link lives in index.html, outside React. Left
 * alone, its click is a fragment navigation that the router sees as a
 * history change and answers with a scroll restoration. Handling the click
 * here keeps it a plain move: the main content scrolls into view (below the
 * sticky header, via scroll-padding-top) and takes focus. The explicit
 * scroll matters because focus() alone does not scroll an element that is
 * already partly on screen, which a page-tall main always is.
 */
const SkipLink = () => {
  useEffect(() => {
    const skip = document.getElementById("skip");
    if (!skip) return;
    const onClick = (event: MouseEvent) => {
      const main = document.getElementById("content");
      if (!main) return;
      event.preventDefault();
      main.scrollIntoView();
      main.focus({ preventScroll: true });
    };
    skip.addEventListener("click", onClick);
    return () => skip.removeEventListener("click", onClick);
  }, []);

  return null;
};

export default SkipLink;
